<template minapp='mpx' xlang='wxml'>
  <button
  class="custom-class es-button"
  wx:class="{{className}}"
  hover-class="es-button--active hover-class"
  form-type="{{ formType }}"
  open-type="{{!disabled && openType}}"
  session-from="{{sessionFrom}}"
  send-message-title="{{sendMessageTitle}}"
  send-message-path="{{sendMessagePath}}"
  send-message-img="{{sendMessageImg}}"
  app-parameter="{{appParameter}}"
  show-message-card="{{showMessageCard}}"
  bindtap="bindNativeEvent('click', $event)"
  bindgetuserinfo="bindNativeEvent('getuserinfo', $event)"
  bindcontact="bindNativeEvent('contact', $event)"
  bindgetphonenumber="bindNativeEvent('getphonenumber', $event)"
  binderror="bindNativeEvent('error', $event)"
  bindopensetting="bindNativeEvent('opensetting', $event)"
  bindlaunchapp="bindNativeEvent('launchapp', $event)"
  >
    <view class="es-button__body">
      <view class="es-button__text">
        <slot></slot>
      </view>
    </view>
  </button>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    externalClasses: ['hover-class'],

    props: {
      size: {
        type: String,
        value: 'normal'
      },
      type: {
        type: String,
        value: 'default'
      },
      plain: {
        type: Boolean,
        value: false
      },
      block: {
        type: Boolean,
        value: false
      },
      round: {
        type: Boolean,
        value: false
      },
      formType: String,
      disabled: Boolean,
      icon: String,
      openType: String,
      sessionFrom: String,
      sendMessageTitle: String,
      sendMessagePath: String,
      sendMessageImg: String,
      showMessageCard: Boolean,
      appParameter: String
    },

    computed: {
      className() {
        const { size, type, plain, block, round, disabled } = this
        return {
          ['es-button--' + size]: true,
          ['es-button--' + type]: true,
          'es-button--plain': plain,
          'es-button--block': block,
          'es-button--disabled': disabled,
          'es-button--round': round
        }
      }
    },

    methods: {
      bindNativeEvent(name, event) {
        if (this.disabled) {
          return
        }
        this.$trigger(name, event.detail)
      }
    }
  })
</script>

<style lang="stylus" src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>

